<template>
    <div ref="container">
      <a-modal :title="title" :width="1000" :visible="visible" :confirmLoading="confirmLoading" :getContainer="() => $refs.container" :maskStyle="{'top':'93px','left':'154px'}" :wrapClassName="wrapClassNameInfo()" :mask="isDesktop()" :maskClosable="false" @ok="handleOk" @cancel="handleCancel" cancelText="关闭" style="top:10%;height: 50%;">
        <template slot="footer">
          <a-button key="back" @click="handleCancel">
            关闭
          </a-button>
          <a-button type="primary" @click="handleOk">
            确认
          </a-button>
        </template>
        <a-spin :spinning="confirmLoading">
          <a-form-model ref="form" :model="form" :rules="rules">
            <a-row class="form-row" :gutter="24">
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="工艺名称" prop="craftName">
                  <a-input placeholder="请输入工艺名称" v-model="form.craftName" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="工艺编码" prop="craftCode">
                  <a-input placeholder="请输入工艺编码" v-model="form.craftCode" />
                </a-form-model-item>
              </a-col>
              <!-- <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="工序序号" prop="seq">
                  <a-input placeholder="请输入工序序号" v-model="form.seq" />
                </a-form-model-item>
              </a-col> -->
            </a-row>
          </a-form-model>
        </a-spin>
      </a-modal>
    </div>
  </template>
  <script>
  import JImageUpload from '@/components/jeecg/JImageUpload'
  import pick from 'lodash.pick'
  import { addTraceProdCraft, editTraceProdCraft } from '@/api/api'
  import { autoJumpNextInput } from '@/utils/util'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import Vue from 'vue'
  import { ACCESS_TOKEN } from '@/store/mutation-types'
  export default {
    name: 'VendorModal',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      JImageUpload,
    },
    data() {
      return {
        title: '操作',
        visible: false,
        fileList: [],
        model: {},
        isReadOnly: false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 18 },
        },
        confirmLoading: false,
        form: {
          craftName: '',
          craftCode: '',
        },
        uploadHeaders: {},
        action: window._CONFIG['domianURL'] + '/systemConfig/upload',
        rules: {
          craftName: [{ required: true, message: '工艺名称不可为空!' }],
          craftCode: [{ required: true, message: '工艺编码不可为空!' }],
        },
        id: '',
      }
    },
    created() {},
    methods: {
      add() {
        this.edit({})
      },
      edit(record) {
        if (this.$refs.form !== undefined) {
          this.$refs.form.resetFields(); // 尝试重置表单字段
        }
        // 手动重置表单数据
        this.form = {
          craftName: '', // 初始化表单字段
          craftCode: '', // 初始化表单字段
          craftType: 1, // 工序序号
        };
        if (record.id) {
          this.form = { ...record }; // 使用对象展开运算符复制对象
          this.id = record.id
        } else {
          this.fileList = []
        }
        this.visible = true
        this.$nextTick(() => {})
      },
      handleChange({ file, fileList }) {
        console.log(file, 'file')
      },
      close() {
        this.$emit('close')
        this.visible = false
      },
      handleOk() {
        const that = this
        // 触发表单验证
        that.$refs['form'].validate(async (success) => {
          if (success === true) {
            let params = {
                craftName: this.form.craftName,
                craftCode: this.form.craftCode,
                segmentType: 1 // 工艺类型：1-工艺，2-流通
            }
            if (this.id) {
              // 编辑
              params.id = this.id
              const res = await editTraceProdCraft(params)
              if (res.code == 200 && res.success == true) {
                this.$message.success(res.result)
                this.close()
                this.form.craftCode = ''
                this.form.craftName = ''
                this.id = ''
                this.$emit('ok')
              } else {
                this.$message.error(res.result)
              }
            } else {
              const res = await addTraceProdCraft(params)
              if (res.code == 200 && res.success == true) {
                this.form.craftCode = ''
                this.form.craftName = ''
                this.$message.success(res.result)
                this.$emit('ok')
                this.close()
              } else {
                this.$message.error(res.result)
              }
            }
          }
        })
      },
      handleCancel() {
        this.close()
      },
      validateSupplierName(rule, value, callback) {
        let params = {
          name: value,
          type: '供应商',
          id: this.model.id ? this.model.id : 0,
        }
        checkSupplier(params).then((res) => {
          if (res && res.code === 200) {
            if (!res.data.status) {
              callback()
            } else {
              callback('名称已经存在')
            }
          } else {
            callback(res.data)
          }
        })
      },
    },
  }
  </script>
  <style scoped>
  </style>